import { ConceptAddAction } from '../types/ConceptAddAction';
import _ from 'lodash';

const initialState: any = [];

const conceptAddReducer = (state = initialState, action: ConceptAddAction) => {
	switch (action.type) {
		case 'CONCEPTS': {
            return {concepts: action.data};
		}
		case 'UPDATE_BENCHMARKING': {
			return {isBenchmarkingUpdated: action.data};
		}
		default:
			return state;
	}
}


export default conceptAddReducer;